import { render, staticRenderFns } from "./InputFileV2.vue?vue&type=template&id=2a00adc1&scoped=true&"
import script from "./InputFileV2.vue?vue&type=script&lang=ts&"
export * from "./InputFileV2.vue?vue&type=script&lang=ts&"
import style0 from "./InputFileV2.vue?vue&type=style&index=0&id=2a00adc1&lang=scss&scoped=true&"
import style1 from "./InputFileV2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a00adc1",
  null
  
)

export default component.exports